export default __webpack_public_path__ + "static/financialtsunami-036e04ece0d43e8d693daf1b86dbe87a.jpg";